export const isFlagEnabled = (
  flags: Record<string, boolean> | null | undefined,
  flag: string
) => !!flags?.[flag];
